import {
  ADD_USER,
  ADD_FIREBASE_TOKEN,
  REMOVE_FIREBASE_TOKEN
} from '../actions/user';
import _ from 'lodash';

const INITIAL_STATE = {
  uid: null,
  displayName: null,
  email: null,
  firebaseToken: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_USER: 
      return Object.assign(state, {
        uid: action.user.uid,
        displayName: action.user.displayName,
        email: action.user.email,
      })
    case ADD_FIREBASE_TOKEN: 
      return Object.assign(state, {
        firebaseToken: action.token
      })
    case REMOVE_FIREBASE_TOKEN: 
      return Object.assign(state, {
        firebaseToken: null
      })
    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/reducers/user.js